import { render, staticRenderFns } from "./SearchDictType.vue?vue&type=template&id=19ebc900&scoped=true&"
import script from "./SearchDictType.vue?vue&type=script&lang=js&"
export * from "./SearchDictType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ebc900",
  null
  
)

export default component.exports